import { applyTheme } from './themeStorage';
import type { Theme } from './types';

/**
 * Prints in the light theme whatever is on screen. Browsers drop backgrounds when printing, so
 * the dark theme's light text would land on white paper. The attribute flips for the print only
 * and is never stored; charts follow it like any other theme switch. Returns the cleanup.
 */
export function printInLightTheme(theme: Theme): () => void {
    if (typeof window === 'undefined' || theme !== 'dark') return () => undefined;
    let flipped = false;
    const beforePrint = () => {
        applyTheme('light');
        flipped = true;
    };
    const afterPrint = () => {
        if (!flipped) return;
        flipped = false;
        applyTheme(theme);
    };
    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);
    return () => {
        window.removeEventListener('beforeprint', beforePrint);
        window.removeEventListener('afterprint', afterPrint);
    };
}
